// extracted by mini-css-extract-plugin
module.exports = {"carousel":"welcomecarousel_carousel__6cH1l","image":"welcomecarousel_image__1Pr4F"};